module.exports = __webpack_public_path__ + "img/product-category-diamondjewelry.01edec6.jpg";